import Global from '../shared/global';

'use strict';
const BannerForm = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.validateForm();
		this.onlyNumbers();
	},
	validateForm() {
		const submit = document.querySelector('.js-banner-form');
		if (!submit) {
			return;
		}

		const validateBannerForm = function() {
			const yourName = document.querySelector('#yourName');
			const yourLastName = document.querySelector('#yourLastName');
			const phoneNum = document.querySelector('#phoneNum');
			const yourEmail = document.querySelector('#yourEmail');
			const pageRedirect = this.getAttribute('data-page');
			const errorPlaceholder = document.querySelector('.js-banner-form-error');
			errorPlaceholder.innerText = '';

			if (yourName.value === '') {
				errorPlaceholder.innerText = 'Please fill first name field';
				return false;
			}
			if (yourLastName.value === '') {
				errorPlaceholder.innerText = 'Please fill last name field';
				return false;
			}
			if (phoneNum.value === '') {
				errorPlaceholder.innerText = 'Please fill phone number field';
				return false;
			}

			if (phoneNum.value.length < 7) {
				errorPlaceholder.innerText = 'Please enter at least 7 numbers';
				return false;
			}

			if (yourEmail.value === '') {
				errorPlaceholder.innerText = 'Please fill email field';
				return false;
			}
			if (!Global.emailValidation(yourEmail.value)) {
				errorPlaceholder.innerText = 'Please enter valid email';
				return false;
			}

			const obj = {
				firstName: yourName.value,
				lastName: yourLastName.value,
				phoneNum: phoneNum.value,
				yourEmail: yourEmail.value
			};

			Global.setCookie('firstStepDate', obj);

			location.href = pageRedirect;
		};

		submit.addEventListener('click', validateBannerForm);
	},
	onlyNumbers() {
		const input = document.getElementById('phoneNum');

		if (!input) {
			return;
		}

		const onlyNum = function() {
			let newVal = this.value.replace(/[^\d]/g, '');
			if (newVal.length > 10) {
				newVal = newVal.substring(0, 10);
			}
			this.value = newVal;
		};

		input.addEventListener('keyup', onlyNum);
	}
};

export default BannerForm;
